import { gql } from "@apollo/client";

export const GET_CUSTOMER_COUNT = gql`
  {
    customersCount
  }
`;